import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/style.css'
import './assets/css/addcss.css'
import $ from 'jquery'

Vue.prototype.$ = $;


import axios  from 'axios'
//axios.defaults.baseURL = 'http://yzapi.gsyzkj.cn/api/'
Vue.prototype.$http = axios
//图片资源路径

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


const userAgentInfo = navigator.userAgent;
const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
for (let i = 0; i < mobileAgents.length; i++) {
if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
  window.location.href = 'https://m.gsyzkj.com';
}
}


